import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'dev-bootstrap-size',
  imports: [],
  templateUrl: './bootstrap-size.component.html'
})

export class BootstrapSizeComponent implements OnInit {

  public ngOnInit(): void {
    this.hidden = !environment.isDevelopment;
  }

  public hidden: boolean = true;

}
